import Translations from './Translations/Translations';

export default Translations;